import { httpClient } from '@/services/http/httpClient'

type AddSSOKeysParams = {
  tennantId: string
  msalClientId: string
  msalClientSecret: string
  msalAuthority: string
  msalRedirectUri: string
  msalGroupId?: string | null
  msalUseAreaUsers?: boolean
}

type AddSSOKeysResponse = {
  success: boolean
  message: string
}

export async function addSSOKeys({
  tennantId,
  msalClientId,
  msalClientSecret,
  msalAuthority,
  msalRedirectUri,
  msalGroupId,
  msalUseAreaUsers,
}: AddSSOKeysParams): Promise<AddSSOKeysResponse> {
  const { data } = await httpClient.post('/tennants/sso-keys', {
    tennantId,
    msalClientId,
    msalClientSecret,
    msalAuthority,
    msalRedirectUri,
    msalGroupId,
    msalUseAreaUsers,
  })

  return data
}
